export default "__VITE_ASSET__1iyWi5bY__"